import { useNavigate } from 'react-router-dom';
import {
  ExclamationCircleOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { warningTitle } from '@/common/custom-date-selector-list/helpers';
import { AntButton } from '@/common/ant-components/AntButton';

/**
 * CreateButton component that renders a button with an icon and title, and navigates to a specified path when clicked.
 *
 * @component
 * @example
 * const path = "/create";
 * const title = "Create Item";
 * return (
 *   <CreateButton path={path} title={title} />
 * )
 *
 * @param {Object} props - Component props.
 * @param {string} props.path - The path to navigate to when the button is clicked.
 * @param {string} props.title - The title to be displayed on the button.
 * @returns {React.Element} The rendered component.
 */
const CreateButton = ({ path, title }) => {
  const app = useSelector((state) => state?.financialData?.data);

  const isActiveFinancialYear = useSelector(
    (state) => state?.financialData?.data?.isActive,
  );

  const { confirm } = Modal;

  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.key === '+' ||
        event.code === 'Equal' ||
        (event.key === '=' && event.shiftKey)
      ) {
        event.preventDefault();
        navigate(path);
      }
      if (event.code === 'Escape') {
        event.preventDefault();
        navigate(-1);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate, path]);

  return (
    <div>
      <AntButton
        className="header-add tw-w-28 "
        size="medium"
        onClick={() => {
          if (!isActiveFinancialYear) {
            confirm({
              title: `${warningTitle} (${app?.financialYearStartDate} to ${app?.financialYearEndDate})?`,
              icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
              onOk: () => {
                navigate(path);
              },
            });
            return;
          } else {
            navigate(path);
          }
        }}
      >
        <PlusCircleOutlined />
        {title}
      </AntButton>
    </div>
  );
};

export default CreateButton;
